import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const InnerWrapper = styled("div")`
    display: flex;
    height: 100%;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;

    align-items: center;
    max-width: ${breakpoints.values.xl}px;
    justify-content: space-between;

    height: 2.75rem;

    padding: 0 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0 2rem;
        height: 3.75rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0 2.5rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0 2.5rem;
    }

    .countrylangselector {
        button {
            pointer-events: none;
        }
        padding-left: 0.875rem;
    }

    .shoppingbag {
        height: auto;
        width: auto;
        padding-right: 0.24rem;
    }

    border-bottom: 1px solid;
    border-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.secure.borderColor};
`
